import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Actions } from '../../Action/index';
import { updateCurationStatus, getQuestionDraftData, fetchAttachmentURL, getTabSearchData, getTrendingData } from '../../API/api';
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import styles from './Styles.module.css'
import { handleError } from '../../utils';
import { CURRENT_ROLE } from '../../API/url';


const buttonLightStyle = {
  minWidh: '96px',
  border: '1px solid #E0E2E6',
  padding: '8px 16px 8px 16px',
  borderRadius: '8px',
  boxShadow: ' 0px 1px 2px 0px #1018280D',
  fontSize: '14px',
  color: '#2A364A',
  // marginRight:'8px',
  background: '#FFFFFF',
  fontWeight: '400',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  // minWidth: `${minWidth}`
}
const buttonDarkStyle = {
  minWidh: '96px',
  border: '1px solid #E0E2E6',
  padding: '8px 16px 8px 16px',
  borderRadius: '8px',
  boxShadow: ' 0px 1px 2px 0px #1018280D',
  fontSize: '14px',
  color: '#2A364A',
  // marginRight:'8px',
  background: '#F6F7F8',
  fontWeight: '400',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  // minWidth:`${minWidth}`,
  // ...(minWidth !== undefined && { justifyContent:'center'})
}
export default function NewCurationButtons({ question, answer, tabsearchQuery ,  fetchData,
  fetchDataCount }) {
  const currentPath = useLocation();
  const submitSuccessToast = (message) => {
    return (
      <>
        <span style={{ fontSize: "12px" }}>
          {message}
        </span>
      </>
    );
  };
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const { markedAnsweredData, updatePageNoAnswered, IsLoadingAnsweredtab, updateAnsweredTabData, IsLoadingSharedWithtab, getScrollPositionInExpertOpen, AnsweredPageBool, updateAnswerTextForEditor } = bindActionCreators(Actions, dispatch)
  const expertAnsweredState = useSelector(state => state.answeredQuestions);
  const userState = useSelector(state => state.user);
  const editorState = useSelector(state => state.editor);
  const [loader, setLoader] = useState(true)
  const dataname = "answeredQuestions"
  let pageState = useSelector((state) => state[dataname]);



  const convertStringToEpoch = (dt) => {
    let date = Date.parse(dt);
    return date;
  }
  const isAnsweredByMe = (arr) => {
    // console.log("array", arr)
    let id = ""
    arr.filter(obj => {
      if (obj.expertUuid === userState.geoAttributes.userId) {
        id = obj.answerUuid;
      }
    })
    return id;
  }
  const appendInlineImageInText = async (arr) => {
    let newArr = await arr.filter(obj => {
      if (obj.expertUuid === userState.geoAttributes.userId) {
        if (obj.inlineImages.length > 0) {
          for (let i = 0; i < obj.inlineImages.length; ++i) {
            let pld = { name: obj.inlineImages[i] }
            fetchAttachmentURL(pld).then(res => {
              if (res === undefined) return;
              if (obj.inlineImages[i].includes(".png")) {
              } else {
                let imgTag = `<img style='max-width:50%' src=${res.data.data.src
                  }></img>`;

                let replacedContent = obj.inlineImages[i];
                obj.answerCopy = obj.answerCopy.replaceAll(
                  replacedContent,
                  imgTag
                );
              }
            })
          }
        }
        return obj;
      }
    })
    updateAnswerTextForEditor(newArr.length === 0 ? "" : newArr[0].answerCopy);
  }

  const isCheckRelevance = (str) => {
    let isThere = false;
    for (let i = 0; i < str.length; ++i) {
      if (str[i].label === "Relevance") {
        isThere = true;
      }
    }
    return isThere;
  };
  const excludedValues = ['transferred', '1', '2', '3']; // Exclude these from filteredDomains
  const curationValues = ['1', '2', '3']; // Values for curationCategory
  // const prevDeps = useRef({});
  const isTransferred = pageState.domains.some(domain => domain.value === 'transferred'); // Check if 'transferred' exists

  const filteredDomains = pageState?.expertDomain?.filter(domain => !excludedValues.includes(domain.value)); // Remove 'transferred', '1', '2', '3'
  const curationCategory = pageState.expertCuration
    ?.filter(domain => curationValues.includes(domain.value)) // Get only '1', '2', '3'
    ?.map(domain => domain.value); // Extract values
  // Extract values
  // console.log("curationCategory", filteredDomains)
  const searchCuration = curationCategory.length > 0 ? curationCategory.map(Number).join(",") : "";

  const searchDomain = filteredDomains.length > 0 ? curationCategory : "";
 
  const onClickButton = (question, answer, key) => {
    // getScrollPositionInExpertOpen(window.scrollY)
    IsLoadingAnsweredtab(true)
    setLoader(false)

    var body = {
      answerUuidStr: answer.answerUuid,
      curationStatus: 'curated',
      evergreen: key === "evergreen" ? true : false
    }
    let payload = [];
    payload.push(body)
    let filteredData = expertAnsweredState.data.filter(obj => {
      if (obj.questionUuid !== question.questionUuid) {
        return obj;
      }
    })
    updateCurationStatus(payload).then(res => {
      if (res === undefined) return;
      if (res.data.success) {
        toast.success(submitSuccessToast(res.data.message), {
          position: toast.POSITION.TOP_RIGHT,
        });

        fetchData()
        fetchDataCount()
      }
    })

  }

  return (
    <>
      {loader &&
        <div style={{ display: "flex", paddingRight: "5px" }}>
          {/* <button style={buttonDarkStyle} onClick={()=>editAnswer(question)}>Edit Answer</button> */}
          &nbsp;
          <button style={buttonDarkStyle} onClick={() => onClickButton(question, answer, 'evergreen')}>Mark Evergreen</button>
          &nbsp;
          <button className={styles.buttonPrimary} onClick={() => onClickButton(question, answer, 'curated')}>Mark Curated</button>
        </div>}

    </>
  )
}
